import { LoadableBackground } from '@confluence/loadable';

export const SuggestWhiteboardOnPageTitle = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumTrialDigestDataModal" */ './SuggestWhiteboardOnPageTitleEligibility.tsx'
			)
		).SuggestWhiteboardOnPageTitleErrorBoundary,
});
